var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.$root.display.showPriceNoBuyButton ||
    (_vm.$root.admin && _vm.$root.display.showPriceNoBuyButton)
      ? _c("div", [
          _vm.onlyBuyWhenLoggedInCheck
            ? _c("div", [
                ((((_vm.availability != 0 && !_vm.backorder) ||
                  (_vm.availability == 0 && (_vm.backorder || _vm.preorder))) &&
                  _vm.availability != 2) ||
                  _vm.availability == 5) &&
                _vm.loaded
                  ? _c(
                      "div",
                      [
                        _c(
                          "transition-group",
                          {
                            attrs: {
                              name: _vm.entry ? "" : "bounce",
                              duration: { enter: 300, leave: 0 },
                            },
                          },
                          [
                            _vm.showAddToBasket &&
                            (((_vm.availability != 0 ||
                              _vm.availability != 2) &&
                              !_vm.backorder &&
                              !_vm.preorder) ||
                              _vm.availability == 5)
                              ? _c(
                                  "button",
                                  {
                                    key: 1,
                                    staticClass: "add",
                                    on: {
                                      click: function ($event) {
                                        return _vm.addToBasket(_vm.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        this.$root.language.wsm_AddToBasket
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.availability == 0 &&
                            (_vm.backorder || _vm.preorder) &&
                            _vm.currentQuant == 0 &&
                            _vm.showAddToBasket
                              ? _c("div", { key: 2 }, [
                                  _vm.backorder
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "add",
                                          on: {
                                            click: function ($event) {
                                              _vm.showModal = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " backorder " +
                                              _vm._s(
                                                this.$root.language
                                                  .wsm_AddToBasket
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  !_vm.backorder && _vm.preorder
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "add notify",
                                          on: {
                                            click: function ($event) {
                                              _vm.showModal = true
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-bell",
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                this.$root.language.wsm_Preorder
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "transition",
                          {
                            attrs: {
                              name: _vm.entry ? "" : "bounce",
                              duration: { enter: 300, leave: 0 },
                            },
                          },
                          [
                            _vm.currentQuant != 0 && _vm.showQuant
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "quantityButtons",
                                    class: {
                                      isSubscription:
                                        _vm.isSubscriptionInBasket,
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "minus",
                                        on: {
                                          click: function ($event) {
                                            return _vm.adjustQuantity("minus")
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fas fa-minus" })]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentQuant,
                                          expression: "currentQuant",
                                        },
                                      ],
                                      attrs: { disabled: "" },
                                      domProps: { value: _vm.currentQuant },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.currentQuant = $event.target.value
                                        },
                                      },
                                    }),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "plus",
                                        on: {
                                          click: function ($event) {
                                            return _vm.adjustQuantity("plus")
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "fas fa-plus" })]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.availability == 0 && !_vm.backorder && !_vm.preorder
      ? _c("div", [
          _c("button", { staticClass: "add outOfStock" }, [
            _vm._v(_vm._s(this.$root.language.wsm_OutOfStock)),
          ]),
        ])
      : _vm._e(),
    _vm.availability == 0 && (_vm.backorder || _vm.preorder)
      ? _c(
          "div",
          [
            _vm.showModal
              ? _c("backorderModal", {
                  attrs: {
                    preorder: _vm.preorder,
                    productid: _vm.id,
                    backorder: _vm.backorder,
                    productname: _vm.productname,
                  },
                  on: {
                    addToBasket: _vm.addToBasket,
                    close: function ($event) {
                      _vm.showModal = false
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.availability == 2
      ? _c(
          "div",
          [
            this.$root.messenger == true ? _c("MessengerButton") : _vm._e(),
            !this.$root.messenger
              ? _c("button", { staticClass: "add outOfStock" }, [
                  _vm._v(_vm._s(this.$root.language.wsm_NotForSale)),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.$root.pointshop &&
              _vm.pointCardPointValue?.pointCardPointValue > 0 &&
              _vm.pointCardPointValue.view == "grid",
            expression:
              "$root.pointshop && pointCardPointValue?.pointCardPointValue  > 0 && pointCardPointValue.view == 'grid'",
          },
        ],
        staticClass: "pointcardvalue",
      },
      [
        _c("p", {
          domProps: {
            innerHTML: _vm._s(
              `${_vm.$root.language.wsm_pointcard_in_box}: ${_vm.pointCardPointValue.pointCardPointValue} ${_vm.pointCardPointValue.CurrencyIso}`
            ),
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }